import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { MiTienda } from './mi-tienda/mi-tienda';
import { isMobileOrTablet } from '../../utils/stores/store-data';
import { StoreService } from '../../services/store.service';
import { Subscription } from 'rxjs';
import { Sucursal } from '../../types/stores';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'allas-my-store-selector',

  imports: [CommonModule, MiTienda, DialogModule],
  template: `
    <!-- Trigger -->
    <div (click)="handleOpen()">
      <ng-content></ng-content>
    </div>

    <!-- Conditional Rendering -->
    <p-dialog
      [(visible)]="isOpen"
      header="Mi Tienda"
      [modal]="true"
      appendTo="body"
    >
      <allas-mi-tienda
        [selectedStoreId]="selectedStoreId"
        (onClose)="handleClose()"
        (onStoreSelect)="handleStoreSelect($event)"
      >
      </allas-mi-tienda>
    </p-dialog>
  `,
})
export class MyStoreSelector implements OnInit, OnDestroy {
  @Input() stores: Sucursal[] = [];
  @Input() selectedStoreId?: string;
  @Output() onStoreSelect = new EventEmitter<Sucursal>();

  isOpen = false;
  isMobile = false;
  selectedStore: Sucursal | null = null;
  private storeSubscription?: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private storeService: StoreService
  ) {}

  ngOnInit(): void {
    this.checkDevice();
    this.loadInitialStore();
    this.subscribeToStore();

    if (isPlatformBrowser(this.platformId)) {
      this.resizeListener = () => {
        this.checkDevice();
      };
      window.addEventListener('resize', this.resizeListener);
    }
  }

  ngOnDestroy(): void {
    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
    if (isPlatformBrowser(this.platformId) && this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }

  private loadInitialStore(): void {
    this.selectedStore = this.storeService.getSelectedStore();
    if (this.selectedStore) {
      this.selectedStoreId = this.selectedStore.id;
    }
  }

  private subscribeToStore(): void {
    this.storeSubscription = this.storeService.selectedStore$.subscribe(
      (store) => {
        this.selectedStore = store;
        this.selectedStoreId = store?.id;
        this.cdr.detectChanges();
      }
    );
  }

  private checkDevice(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = isMobileOrTablet();
      this.cdr.detectChanges();
    }
  }

  handleOpen(): void {
    if (this.isMobile) {
      // Navigate to the store page route
      this.router.navigate(['/mi-tienda']);
    } else {
      // Open modal
      this.isOpen = true;
    }
  }

  handleClose(): void {
    this.isOpen = false;
  }

  handleStoreSelect(store: Sucursal): void {
    this.storeService.setSelectedStore(store);
    this.onStoreSelect.emit(store);
    this.isOpen = false;
  }

  private resizeListener?: () => void;
}
